// Types
import type { ComponentPropsWithRef } from 'react';
import { forwardRef } from 'react';

import clsx from 'clsx';

type RadioButtonProps = ComponentPropsWithRef<'input'>;

const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
    ({ id, checked, children, className, ...restProps }, ref) => (
        <label
            htmlFor={id}
            className={clsx(
                'w-auto max-w-fit cursor-pointer rounded-full border px-4 py-2 text-xs',
                {
                    'border-icoGray-300 bg-white font-GMedium text-icoGray-500 dark:border-icoDarkMode-beton dark:bg-icoDarkMode-anthracite dark:text-icoDarkMode-wolf':
                        !checked,
                    'border-icoBlue-200 bg-icoBlue-100 font-GSemiBold text-icoBlue dark:border-icoBlue dark:bg-icoBlue/20':
                        checked
                },
                className
            )}>
            {children}
            <input
                ref={ref}
                id={id}
                type="radio"
                className="hidden"
                checked={checked}
                {...restProps}
            />
        </label>
    )
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
